var _ellipse, _path, _ellipse2, _ellipse3, _ellipse4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInFourEyesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.1657,
    cy: 21.6001,
    rx: 20.9821,
    ry: 21,
    fill: "#E1EAF6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1659 10.75C14.9587 10.75 10.5874 15.825 7.0904 19.7625C6.12872 20.8125 6.12872 22.3875 7.0904 23.4375C10.7623 27.4625 14.9587 32.45 21.1659 32.45C27.3731 32.45 31.4821 27.4625 35.2414 23.4375C36.2031 22.3875 36.2031 20.8125 35.2414 19.7625C31.3073 15.5625 27.4606 10.75 21.1659 10.75Z",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.1656,
    cy: 21.6001,
    rx: 7.43118,
    ry: 7.4375,
    fill: "#0071C2"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.165,
    cy: 21.6001,
    rx: 3.49702,
    ry: 3.5,
    fill: "#46484A"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.4165,
    cy: 18.9751,
    rx: 1.74851,
    ry: 1.75,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInFourEyesIcon);
export default __webpack_public_path__ + "static/media/inFourEyesIcon.df830e49d6d2b54210d75b6d8985a8ed.svg";
export { ForwardRef as ReactComponent };